/** 홍보 영상 검수 화면 (pages/todaymall/promoVideo). */
export default {
  'pages.promoVideo.title': "宣传视频审核",
  'pages.promoVideo.hint': "请完整观看视频，确认商品形状、颜色、标志与原图一致后再批准。只有批准的视频才会附在分享中。",
  'pages.promoVideo.health.ok': "视频服务器正常",
  'pages.promoVideo.health.degraded': "视频服务器异常",
  'pages.promoVideo.health.off': "功能关闭",
  'pages.promoVideo.health.queue': "排队 {n} 个",
  'pages.promoVideo.tab.review': "待审核",
  'pages.promoVideo.tab.approved': "已批准",
  'pages.promoVideo.tab.making': "制作中",
  'pages.promoVideo.tab.failed': "失败",
  'pages.promoVideo.tab.rejected': "已驳回",
  'pages.promoVideo.tab.all': "全部",
  'pages.promoVideo.status.queued': "排队中",
  'pages.promoVideo.status.generating': "制作中",
  'pages.promoVideo.status.review': "待审核",
  'pages.promoVideo.status.approved': "已批准",
  'pages.promoVideo.status.rejected': "已驳回",
  'pages.promoVideo.status.failed': "失败",
  'pages.promoVideo.col.poster': "视频",
  'pages.promoVideo.col.product': "商品",
  'pages.promoVideo.col.source': "来源",
  'pages.promoVideo.col.status': "状态",
  'pages.promoVideo.col.price': "价格",
  'pages.promoVideo.col.requests': "分享请求",
  'pages.promoVideo.col.updated': "更新",
  'pages.promoVideo.action.view': "查看",
  'pages.promoVideo.action.approve': "批准",
  'pages.promoVideo.action.reject': "驳回",
  'pages.promoVideo.action.regenerate': "选图重新生成",
  'pages.promoVideo.action.recompose': "仅重绘文字",
  'pages.promoVideo.action.request': "指定商品生成",
  'pages.promoVideo.action.openProduct': "商品页面",
  'pages.promoVideo.action.search': "搜索",
  'pages.promoVideo.action.refresh': "刷新",
  'pages.promoVideo.reject.reason': "驳回原因（可选）",
  'pages.promoVideo.detail.title': "视频中的商品名",
  'pages.promoVideo.detail.captions': "字幕（每个镜头一条）",
  'pages.promoVideo.detail.price': "售价（韩元）",
  'pages.promoVideo.detail.tagPrice': "原价（韩元，用于折扣）",
  'pages.promoVideo.detail.photos': "选择用于AI镜头的图片（建议排除说明图、规格表）",
  'pages.promoVideo.detail.photoAi': "AI",
  'pages.promoVideo.detail.photoInfographic': "说明图",
  'pages.promoVideo.detail.shots': "使用的镜头",
  'pages.promoVideo.detail.shotClip': "AI镜头",
  'pages.promoVideo.detail.shotImage': "图片缩放",
  'pages.promoVideo.detail.qc': "与原图相似度",
  'pages.promoVideo.detail.music': "背景音乐",
  'pages.promoVideo.detail.lastError': "错误",
  'pages.promoVideo.detail.progress': "进度",
  'pages.promoVideo.detail.noVideo': "还没有视频。",
  'pages.promoVideo.detail.recomposeHint': "仅重绘文字不使用GPU，约10秒。镜头不满意时请选图重新生成（约3分钟）。",
  'pages.promoVideo.msg.approved': "已批准，分享中将附上视频链接。",
  'pages.promoVideo.msg.rejected': "已驳回。",
  'pages.promoVideo.msg.regenerating': "已开始重新生成，约需3分钟。",
  'pages.promoVideo.msg.recomposed': "文字已重绘。",
  'pages.promoVideo.msg.requested': "已请求生成。",
  'pages.promoVideo.msg.pickPhoto': "请至少选择一张图片。",
  'pages.promoVideo.form.source': "来源",
  'pages.promoVideo.form.productId': "商品编号",
  'pages.promoVideo.form.search': "商品名或编号",
  'pages.promoVideo.form.link': "商品链接",
  'pages.promoVideo.form.linkPlaceholder': "https://detail.1688.com/offer/….html",
  'pages.promoVideo.form.linkHelp': "请粘贴1688、淘宝（天猫）、VVIC的商品地址，或TodayMall的商品／分享地址。短链接请先打开后粘贴完整地址。",
  'pages.promoVideo.form.linkRequired': "请粘贴商品链接。",
};
